import isUndefined from 'lodash/isUndefined';
export const translate = (text, t, te, param = null) => {
    if (!isUndefined(text)) {
        if (te(text)) {
            return t(text, param);
        }
        else {
            return text;
        }
    }
    else {
        return '';
    }
};
